import React from 'react';
import LanguageSelector from '../selectors/LanguageSelector';
import { ReactComponent as MonsterStudent } from '../../assets/images/Monster-student.svg';
import { ReactComponent as BackgroundBlob } from '../../assets/images/blob-animation.svg';
import LogoText from '../LogoText';

// Needs a better name, this container is intended for Login / Register and Error Page
const NoAuthFormContainer = ({
	children,
  noMonster
}: {
	children?: React.ReactNode;
  noMonster?: boolean;
}) => {
	return (
		<main className='flex flex-col relative overflow-hidden min-h-screen bg-gradient-to-t from-mint-100 to-white place-content-center place-items-center'>
			<div className='block sm:absolute right-1 top-1 z-50'>
				<LanguageSelector collapsed={false} />
			</div>
      <LogoText />
			<div className='max-w-2xl min-h-screen flex flex-col relative z-40 place-items-center place-content-center'>
				<div className='flex lg:hidden text-center flex-col justify-center'>
					<div className='select-none font-blanch font-medium text-7xl md:text-9xl mussila-logo w-fit'><a href='https://mussila.com' aria-label='mussila website'>mussila</a></div>
				</div>
				{/* {noMonster ?? <MonsterStudent className='my-2 inline xl:invisble xl:w-0 xl:h-0 w-1/2 h-1/2 place-self-center' />} */}
				<div className='flex flex-col py-4'>
          {children}
        </div>
			</div>
			{noMonster ?? <MonsterStudent className='absolute bottom-5 left-5 z-20 hidden xl:inline' />}
			<BackgroundBlob className='absolute hidden sm:block lg:w-4/5 2xl:w-3/5 z-10 text-celestial-blue-200' />
		</main>
	);
};

export default NoAuthFormContainer;
